import { render, staticRenderFns } from "./AutoSuggest.vue?vue&type=template&id=52fd45a2&"
import script from "./AutoSuggest.vue?vue&type=script&lang=js&"
export * from "./AutoSuggest.vue?vue&type=script&lang=js&"
import style0 from "./AutoSuggest.vue?vue&type=style&index=0&id=52fd45a2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports